
import Layout from "../../components/mainPage/Layout";

export const Page = () => {
    return (

        <Layout>
            <div className="container">
                <div className="article-container">
                    <h1 className="mb-4 ">
                        Перечень протоколов и интегрируемых устройств
                    </h1>
                    <table className="table table-striped table-bordered">
                        <thead>
                            <TableHeader />
                        </thead>
                        <tbody>
                            <TableBody />
                        </tbody>
                    </table>

                </div>
            </div>
        </Layout>

    );
};

const TableHeader = () => {
    return <tr  >
        <th className="p-4" style={{
            background: 'var(--accent-color)',
            color: 'white'
        }}>Протокол</th>
        <th className="p-4" style={{
            background: 'var(--accent-color)',
            color: 'white'
        }}>Устройства</th>
    </tr>
}
const TableBody = () => {
    return <>
        <tr>
            <td>ГОСТ Р МЭК 60870-5-101</td>
            <td>
                <div>ETL, CP24 (АББ)</div>
                <div>ПА СР-24 Юнител-Групп</div>
                <div>ПА АКА-Кедр</div>
                <div>ПВЗУ-Е</div>
                <div>РАС ГОСАН, ЧЯ (Черный ящик)</div>
                <div>Контроллеры управления РПН Tapcon</div>
                <div>ЦУ передачи команд по ВЧ-каналу УПК-Ц</div>
                <div>Счетчики Satec Ltd.</div>
                <div>Плавка гололеда СУРЗА ВУПГ 14/1200(1600)</div>
            </td>
        </tr>
        <tr>
            <td>ГОСТ Р МЭК 60870-5-103</td>
            <td>
                <div>РЗА НПП «ЭКРА»</div>
                <div>РЗА ИЦ «Бреслер» (ТОР200)</div>
                <div>РЗА Siemens (SIPROTEC, 7UT633)</div>
                <div>РЗА ALSTOM (P40 Agile)</div>
                <div>Контроллеры управления РПН Tapcon</div></td>
        </tr>

        <tr>
            <td>ГОСТ Р МЭК 60870-5-104</td>
            <td><div>РЗА АББ 5-серии (с применением шлюза COM 610)</div>
                <div>РЗА GE Multilin</div>
                <div>МКПА, УПАЭ</div>
                <div>РАС «НПП Бреслер»</div>
                <div>РАС ГОСАН, ЧЯ (Черный ящик)</div>
                <div>РАС НЕВА</div>
                <div>АУРА</div>
                <div>Контроллер ЩПТ НПП «ЭКРА»</div>
                <div>Контроллер ЩСН НПП «ЭКРА»</div>
                <div>Мониторинг АТ «АСУ-ВЭИ» СУМТО</div>
                <div>Мониторинг АТ – Интера</div>
                <div>Мониторинг высоковольтн. кабеля ООО «Седотек»</div>
                <div>ПТК ССПТИ ЗАО «КРОК»</div>
                <div>ШАРМ СУМ</div>
                <div>Счетчики Satec Ltd.</div>
                <div>Счетчики КИПП-2М</div>
                <div>Телеканал-2М</div>
                <div>Станционная Экра ШЭ111х</div>
                <div>Контроллер многофункциональный NPT</div>
                <div>Контроллер Sprecon-E-Cxx</div>
                <div>УСО SMART-КП Электра ЗАО «РТСофт»</div>
                <div>МИП 02 ЗАО «РТСофт»</div>
                <div>МИП ЭНИП-2</div>
                <div>Плавка гололеда СУРЗА ВУПГ 14/1200(1600)</div>
                <div>ЦППС «КОТМИ»</div></td>
        </tr>
        <tr>
            <td>IEC 61850-8-1 (MMS, GOOSE)</td>
            <td>
                <div>РЗА НПП «ЭКРА»</div>
                <div>РЗА ИЦ «Бреслер» (ТОР200, ТОР300)</div>
                <div>РЗА АББ 6-серии</div>
                <div>РЗА ABB REG 670</div>
                <div>ABB Устройства Relion серии 670</div>
                <div>РЗА Siemens (SIPROTEC)</div>
                <div>РЗА GE Multilin</div>
                <div>РЗА ALSTOM (P40 Agile)</div>
                <div>РЗА Schneider Electric SEPAM 80 NPP</div>
                <div>РЗА ООО «АСТ»</div>
                <div>МКПА, УПАЭ</div>
                <div>РАС НЕВА</div>
                <div>КП Satec SA 330</div>
                <div>Контроллер многофункциональный NPT</div>
                <div>УСО Siprotec 6MD613</div>
                <div>МИП ЭНИП-2</div>
            </td>
        </tr>
        <tr>
            <td>Modbus (RTU, TCP)</td>
            <td> <div>РЗА GE Multilin</div>
                <div>РЗА Schneider Electric SEPAM</div>
                <div>Дуговая защита ОВОД</div>
                <div>РЗА ООО «РЗА СИСТЕМЗ»</div>
                <div>РЗА БМРЗ «Механотроника»</div>
                <div>Контроллер управления ДГР МИРК 4.2</div>
                <div>ЦС Сириус «Радиус-Автоматика»</div>
                <div>Сириус РНМ-1 «Радиус-Автоматика»</div>
                <div>Сириус-2-ОМП</div>
                <div>ПА АЛАР-Ц</div>
                <div>Smart-ПА (РТСофт)</div>
                <div>ОМП ИМФ-3Р, ИМФ-3С</div>
                <div>Контроллер ЩСН Siemens</div>
                <div>Контроллер ЩПТ «Завод Конвертор»</div>
                <div>Контроллер ЩСН «Завод Конвертор»</div>
                <div>Контроллер ЩСН ICPcon</div>
                <div>Контроллер Climatix (Siemens)</div>
                <div>Управление РПН Tapcon</div>
                <div>ЦУ передачи команд по ВЧ-каналу УПК-Ц</div>
                <div>Мониторинг выключателя ALSTOM CBWatch</div>
                <div>Счетчики Satec Ltd.</div>
                <div>Станционная Экра ШЭ111х</div>
                <div>Счетчики ION Schneider Electric</div>
                <div>ADAM 40ХХ</div>
                <div>КП Satec SA 330</div>
                <div>Указатель положения УП-2x</div>
                <div>МИП AET4xx</div></td>
        </tr>
        <tr>
            <td>SNMP</td>
            <td><div>RuggedCom - сетевые коммутаторы</div>
                <div>Hirschmann - сетевые коммутаторы</div>
                <div>MOXA - сетевые коммутаторы</div>
                <div>Kyland - сетевые коммутаторы</div>
                <div>Nateks - сетевые коммутаторы</div>
                <div>QTech - сетевые коммутаторы</div>
                <div>CISCO - сетевые коммутаторы</div>
                <div>ФОРПОСТ, СГЭП - системы электропитания</div>
            </td>
        </tr>
        <tr>
            <td>ОРС</td>
            <td>РАС ПАРМА</td>
        </tr>
        <tr>
            <td>Старт</td>
            <td><div>Сириус РНМ-1 «Радиус-Автоматика»</div>
                <div>ОМП ИМФ-3Р, ИМФ-3С</div></td>
        </tr>
        <tr>
            <td>ASCII</td>
            <td><div>ADAM 40ХХ</div>
                <div>Метеостанция Viasala WXT520</div></td>
        </tr>
        <tr>
            <td>SPA-bus</td>
            <td><div>РЗА ИЦ «Бреслер» (ТОР100)</div>
                <div>РЗА АББ 5-серии</div>
                <div>РЗА 6-35 кВ SPAC 810</div></td>
        </tr>
        <tr>
            <td>ION</td>
            <td>Счетчики ION Schneider Electric</td>
        </tr>
        <tr>
            <td>DNP3</td>
            <td>
                <div>Контроллеры Микроника</div>
                <div>Контроллеры АСУТП GE D25</div>
                <div>КП Satec SA 330</div></td>
        </tr>
    </>
}

export const meta = {
    title: 'Перечень протоколов и интегрируемых устройств',
    description: 'Перечень протоколов и интегрируемых устройств'
}